import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import $ from 'jquery';

class CreateNewAccountForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
				username_newacc: '',
				email_newacc: '',
				phone_newacc: '',
				otp_newacc: '',
				password_newacc: '',
				confirmpassword_newacc: '',
				submitButtonDisabled: false,
				serverMessage: "",
				emailfeedbackmsg: "",
				source:"plp",
				isOTPSend:false,
				isVerified:false,
				OTPDisabled:"hidden",
				verifyDisabled:"disabled",
				emailDisabled:false,
				phoneDisabled:false,
				verifyText:this.rb("register.verify"),
				sendOTPText:this.rb("register.sendOTP")
		};

		this.navigationKey="PLP_Navigation";
		
		this.handleChange = this.handleChange.bind(this);
		this.OTPChange = this.OTPChange.bind(this);
		this.enterOTPChange = this.enterOTPChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showforgotPwd = this.showforgotPwd.bind(this);
		this.sendOTP = this.sendOTP.bind(this);
		this.verifyOTP = this.verifyOTP.bind(this);
		this.getOTPField = this.getOTPField.bind(this);
		this.googleLogin = this.googleLogin.bind(this);
		this.doLumosLogout = this.doLumosLogout.bind(this);
		
		this.myTrackerInstance = this.getTracker();
	}

	componentDidMount(){
		this.sessionCheck();
	} 


	handleChange(e) {
		const target = e.currentTarget;	
		//console.log("target=",target);
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled: !this.form.isValid()
		});
	}

	OTPChange(e) {   	
		//console.log(e.currentTarget);
		const target = e.currentTarget;	
		
		if(target.name == "email_newacc"){
			this.setState({ OTPDisabled: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
			if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: ""});
			}
		}
		/*if(this.phone.value.length == 10 || this.email.value.length > 0){
			this.setState({ OTPDisabled: ""});
		}else{
			this.setState({ OTPDisabled: "disabled"});
		}*/
		
		/*if(this.email.value.length>0){
			this.setState({ emailDisabled: false, phoneDisabled:true});
		}
		else if(this.phone.value.length>0){
			this.setState({ emailDisabled: true, phoneDisabled:false});
		}else{
			this.setState({ emailDisabled: false, phoneDisabled:false});
		}*/
		this.handleChange(e);
	}
	enterOTPChange(e){
		if(this.otp.value.length > 0){
			this.setState({ verifyDisabled: ""});
		}else{
			this.setState({ verifyDisabled: "disabled"});
		}
		this.handleChange(e);
	}
	
	hmNav = function(){		
		//this.props.myProps.history.push(this.props.navigateURL);
		window.top.location.href = this.props.navigateURL;
	}
	doLumosLogout(){
		var me = this;
		console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
	            url: me.getUrlFor("LUMOS_LOGOUT"),	            
	            type: 'GET',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			
	    		},
	            error: function(response){
	    			console.log("Error in LUMOS_LOGOUT",response);
	    		}
	    });
	}

	submitForm = function(){
		var verificationtype = "email";
		if(this.state.emailDisabled){
			verificationtype = "phone";
		}
		var formData = {
				"userName" : this.state.username_newacc,
				"loginId" : this.state.email_newacc,
				"userRole" : {
					"role" : "PRNT",
					"level": "1"
				},
				"email" : this.state.email_newacc,
				"phone" : this.state.phone_newacc,
				"token" : this.state.otp_newacc,
				"countryCode" : "IN",
				"password" : this.state.password_newacc,
				"verificationType" : verificationtype,
				"regnProvider" : "heymath"
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status.toLowerCase() == "success"){	
					new UserStore().store(response.user);
					//me.props.successRegisterMsg(me.rb("register.success.msg"));
					
					try{
						me.doLumosLogout();
					}catch(e){}
					
					me.trackMe(true,"register");
					me.hmNav();
				}else{
					
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists"});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The Passcode entered is incorrect"});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured"});
					}else if(response.status == "empty_inputs"){
						me.setState({serverMessage:"Please enter all the fields"});
					}else if(response.status == "token_not_verified"){
						me.setState({serverMessage:"Passcode Verification is required"});
					}else if(response.status == "provider_forbidden"){
						me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google"});
					}
					else{
						me.setState({serverMessage:response.status});
					}
					me.trackMe(false,"register");
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_REGISTER");
			me.showAlert("","Error in CREATE_REGISTER");
			me.trackMe(false,"register");
		}

		new HmAjax(this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);
		new UserStore().clearOldUser();
	}
	
	trackMe(result,source){			
		var trackObj = {
				"name": this.state.username_newacc,
			    "email": this.state.email_newacc,
			    "phone": this.state.phone_newacc,
			    "event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
			    
		}

		this.initiateTrack("signup",trackObj);
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   


			this.submitForm();    


		}
	}
	
	
	showforgotPwd(){
		this.props.callbackForgotPwd(this.state.source)
	}
	sendOTP(){
		var me =this;
		var otpServerMsg = "";
		if(me.state.isOTPSend){
			otpServerMsg = "Passcode is sent again to your email";
		}else{
			otpServerMsg = "Passcode is sent to your email";
		}
		
		me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:true,isVerified:false,verifyDisabled:"disabled",otp_newacc:""});
		var verificationtype = "email";
		if(this.state.emailDisabled){
			verificationtype = "phone";
		}
		var formData = {
				"contactId":this.state.email_newacc,
				"contactName":this.state.username_newacc,
				"contactType":verificationtype
		}
		if(this.state.emailDisabled){
			formData = {
					"contactId":this.state.phone_newacc,
					"contactType":"phone"
			}
		}
		

		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists"});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The Passcode entered is incorrect"});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured"});
					}else{
						me.setState({emailfeedbackmsg:otpServerMsg});
					}
				}
				
				if(response.status == "success"){
					me.trackMe(true,"send_otp");
				}else{
					me.trackMe(false,"send_otp");
				}
						
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_SENDVERIFICATION_TOKEN");		
			me.trackMe(false,"send_otp");
		}

		new HmAjax(this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);
	}
	verifyOTP(){
		var me =this;
		me.setState({serverMessage:""});
		var verificationtype = "email";
		if(this.state.emailDisabled){
			verificationtype = "phone";
		}
		var formData = {
				"verificationId":this.state.email_newacc
		}
		if(this.state.emailDisabled){
			formData = {
					"verificationId":this.state.phone_newacc
			}
		}
		

		
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists"});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The Passcode entered is incorrect"});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured"});
						me.trackMe(false,"verify_otp");
					}else{
						me.setState({isVerified:true});
						me.trackMe(true,"verify_otp");
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_SENDVERIFICATION_TOKEN");		
			me.trackMe(false,"verify_otp");
		}

		new HmAjax(this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);
	}
	getOTPField(){
		if(this.state.isOTPSend){
			return(
					<FormGroup for="otp_newacc">
						<FormControlInput type="otp_newacc" className="otp_newacc" name="otp_newacc" placeholder={this.rb("register.enterOTP")}	
						innerRef={otp => this.otp = otp}	
						value={this.state.otp_newacc} onChange={this.enterOTPChange}
						required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
							<FieldFeedbacks for="otp_newacc">
						<FieldFeedback when="valueMissing">{this.rb("register.enterOTP")}</FieldFeedback>
						<FieldFeedback when="*" />
							</FieldFeedbacks>
					</FormGroup>
			);
		}
	}
	getVerifyField(){
		if(this.state.isOTPSend && !this.state.isVerified){
			return (<div className={"submitButton verifyButton float-right "+this.state.verifyDisabled} onClick={this.verifyOTP} >{this.rb("register.verify")}</div>);
		}else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}
		
	}
	sendOTPText(){
		if(this.state.isOTPSend){
			return(this.rb("register.reSendOTP"));
		}else{
			return(this.rb("register.sendOTP"));
		}
	}
	showEmailFeedback(){
		if(this.state.isOTPSend){
			return(
				<div className="form-control-feedback">
					<div className="error">{this.state.emailfeedbackmsg}</div>
					<div className="feedbacksmall"><i>All important information will be sent to this email ID</i></div>
				</div>
			);
		}
	}
	googleLogin(){
		var navigateObj = {
			navigateURL:this.props.navigateURL
		}
		BrowserStorageUtil.storeSessionItem(this.navigationKey, JSON.stringify(navigateObj));

		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});
			this.tracked = true;
		}

		window.top.location.href = this.getUrlFor("GOOGLE_LOGIN_API");
	}
	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { return (
				<div id="loginRoot" className="plpLogin">
								
				<div className="container">
				
				<div className="row">
				<div className="col-md-12">

				<div className="row">
				<div className="col-md-12 mx-auto">
				<div className="rounded-0">

				<div className="text-center ">
				
				<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
				onSubmit={this.handleSubmit} noValidate>
				
				<FormGroup for="username_newacc">
					<FormControlInput type="username_newacc" className="username_newacc" name="username_newacc" placeholder={this.rb("billing.fullname")}
						value={this.state.username_newacc} onChange={this.handleChange}
					required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
						<FieldFeedbacks for="username_newacc">
					<FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>					 
					<FieldFeedback when="*" />
						</FieldFeedbacks>
				</FormGroup>
				
				<FormGroup for="email_newacc">
					<FormControlInput type="email_newacc" className="email_newacc" name="email_newacc" placeholder={this.rb("fpwd.email")}
						innerRef={email => this.email = email}
					value={this.state.email_newacc} onChange={this.OTPChange} disabled={this.state.emailDisabled}				
					required pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$" maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
					
					<FieldFeedbacks for="email_newacc">
						<FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
						<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>					
					</FieldFeedbacks>	
						
				</FormGroup>
				
				
				
				<div className="clearfix">
					<div className="float-left emailfeedback">
						{this.showEmailFeedback()}				
					</div>
					<div className="float-right">
						<div className={"submitButton OTPButton float-right "+this.state.OTPDisabled} onClick={this.sendOTP} >{this.sendOTPText()}</div>
					</div>
				</div>
				
				
				
				<div className="clear clearfix"></div>
				
				{this.getOTPField()}
				
				{this.getVerifyField()}			
				
				{/*<hr className="hr-text" data-content="or" />*/}
				<FormGroup for="phone_newacc">
					<FormControlInput type="phone_newacc" className="phone_newacc" name="phone_newacc" placeholder={this.rb("register.phone")}
					innerRef={phone => this.phone = phone}	
					value={this.state.phone_newacc} onChange={this.handleChange}	
					pattern=".{10,}" maxLength={20} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
						<FieldFeedbacks for="phone_newacc">		
							<FieldFeedback when="valueMissing">{this.rb("register.mobilerequired")}</FieldFeedback>
							<FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>
							 <FieldFeedback when={value => (value.length>0 && !/\d/.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback>							 
							<FieldFeedback when="*" />
						</FieldFeedbacks>
				</FormGroup>
				
				<div className="clear clearfix"></div>
				
				
				
				
				<FormGroup for="password_newacc">
					<FormControlInput type="password" className="password_newacc" name="password_newacc" placeholder={this.rb("login.password")}						
					innerRef={password => this.password = password}
					value={this.state.password_newacc} onChange={this.handleChange}
					required minLength={6} maxLength={50}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
					<FieldFeedbacks for="password_newacc">
					<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
					<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
					</FieldFeedbacks>
				</FormGroup>
				
				<FormGroup for="confirmpassword">
					<FormControlInput type="password" className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder={this.rb("rpwd.confirmpwd")}
						innerRef={confirmpassword => this.confirmpassword = confirmpassword}
					value={this.state.confirmpassword_newacc} onChange={this.handleChange}				
					required minLength={6} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5" />
					
					<FieldFeedbacks for="confirmpassword_newacc">
						<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
						<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
						<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
					</FieldFeedbacks>					
				</FormGroup>
				
				<div className="server-messages">{this.state.serverMessage}</div>
				
				<button data-ga="Home - Sign in - Users who want to register - Sign Up" disabled={this.state.submitButtonDisabled} className="submitButton signup">{this.rb("register.signup")}</button>
				</FormWithConstraints>	
				</div>
				</div>
				</div>


				</div>

				</div>
				</div>
				<div className="loginTop">				
				<div className="text-center josefin mt-20">OR</div>
					<div className="socialLoginContainer text-center">
						{/*<div className="socialLoginButtons facebook">
							<i className="fab fa-facebook"></i>
							{this.rb("login.facebook")}
						</div>*/}
						<div data-ga="Home - Users who have independently registered - Sign Up - New User - Sign in with Google - Start Learning" className="socialLoginButtons google" onClick={this.googleLogin}>
							<i className="fab fa-google"></i>
							{this.rb("login.google")}
						</div>
					</div>
					
					
				</div>
				
				</div>
				
			
			
				</div>
		);}
	}
}

export default CreateNewAccountForm;



// WEBPACK FOOTER //
// ./src/views/login/CreateNewAccountForm.js